import {Component, Input, OnInit} from '@angular/core';
import {SubscriptionService} from "../../../shared/services/subscription.service";
import {properties} from '../../../../environments/properties';

@Component({
    selector: 'app-freshpass-benefits',
    templateUrl: './freshpass-benefits.component.html',
    styleUrls: ['./freshpass-benefits.component.scss']
})
export class FreshpassBenefitsComponent implements OnInit {

    @Input() freshpassBenefitsJSON;
    @Input() currentEnvironment;

    properties = properties;

    tileObj: any;
    tileArray: Array<object>;
    domain: any;
    tileImage;
    environment;
    freshpassTilesComponent: any;
    showFreshpassTilesComponent = false;

    constructor(public subscriptionService: SubscriptionService) {
    }

    ngOnInit(): void {
        if (this.subscriptionService.getApplicationDomainURL()) {
            this.domain = this.subscriptionService.getApplicationDomainURL();
        }
        this.environment = this.subscriptionService.getEnvironment()
        this.initFreshpassBenefitTiles()
    }

    initFreshpassBenefitTiles(): void {
        if (this.freshpassBenefitsJSON) {
            let tileProperties = Object.keys(this.freshpassBenefitsJSON);
            this.tileArray = [];
            
            for (const prop of tileProperties) {
                const currentTile = this.freshpassBenefitsJSON[prop];
                if (currentTile.fileReference && currentTile.rteTitle) {
                  if (currentTile.fileReference) {
                      currentTile.tileImage = currentTile.fileReference;
                  } 
                //   else {
                //       currentTile.tileImage = currentTile.fpImage;
                //   }
                  this.tileArray.push(currentTile);
                }
            }
        }
    }
}
